module.exports = __webpack_public_path__ + "images/active-sending-ce4c607df4a79ea4d1846c2fcb4deab2.png";